import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBdyyUcHbzm3fkRckVf_P6d2VD1ZdptzOI",
  authDomain: "instituto-copleston.firebaseapp.com",
  projectId: "instituto-copleston",
  storageBucket: "instituto-copleston.firebasestorage.app",
  messagingSenderId: "311746651830",
  appId: "1:311746651830:web:90327d0db03cecb55ae817"
};

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

export { app, auth, db, googleProvider };
